import React from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { Search } from "app/shared/antd/search";

type Props = {
  onSearch?: (value: string) => void;
  placeholder?: string;
}

class SearchInput extends React.Component<WrappedComponentProps & Props> {
  render() {
    const { onSearch, placeholder } = this.props;

    return (
      <Search className={"search-input"}
              placeholder={placeholder ? placeholder : this.props.intl.formatMessage({ id: "search" }) + " ..."}
              autoComplete={"off"}
              onChange={(e) => onSearch ? onSearch(e.target.value) : null}
              onSearch={onSearch} />
    );
  }
}

export default injectIntl(SearchInput);
